import { titleize } from '@/helpers/formatText'
import { SearchableCombobox, TSearchable } from '../../base/combobox'
import { useCombobox } from '@/helpers/useCombobox'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

const values = ['staff', 'crew']

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<string>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => ({
      id: item,
      name: titleize(item),
    })
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
